export class SchoolEnrollmentComments {
    ID: number;
    SCHOOL_ENROLLMENTS_ID: number;
    COMMENT: string;
    MERGED_RECORD: number;
    CREATED_BY: string;
    CREATED_DATE: Date;
    MODIFIED_BY: string;
    MODIFIED_DATE: Date;
    SCHOOL_ENROLLMENTS: string;
}
